<div class="d-none d-sm-none d-md-block ">
    <app-logo-toolbar></app-logo-toolbar>
</div>
<div class="d-block d-sm-block d-md-none">
    <mat-toolbar color="primary" class="shadow mb-1">
        <div class="container-fluid">
            <div class="row">
                <div class="col-1 p-0">
                    <span (click)="stepBack(currentTab)"><fa-icon [icon]="faArrowLeft" class="fa-solid fa-arrow-left "></fa-icon></span>
                </div>
                <div class="col-11 d-flex justify-content-center p-0">
                    <span class="serviceMobile"> {{ 'SERVICE_PAGE.LABEL1' | translate }} </span>
                </div>
            </div>
        </div>
    </mat-toolbar>
</div>
<app-info-toolbar></app-info-toolbar>
<app-spinner *ngIf="loading"></app-spinner>

<div class="container-fluid" style="background-color: #fafafa;">
    <div class="row containerRow ">
        <div class="col-3 d-none d-sm-none d-md-block" style="padding-right:2%">
            <div class="row">
                <div class="col">
                    <app-breadcrumb></app-breadcrumb>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-12">
                    <span class="serviceTitle"> {{ 'SERVICE_PAGE.LABEL2' | translate }} </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-9" style="padding-left:2%">
            <div class="d-none d-sm-none d-md-block col-12 mt-4">
                    <app-timeline [steps]="tabs" [currentStep]="currentTab"></app-timeline>
            </div>
            <div class="d-block d-sm-block d-md-none col-12 mt-4" *ngIf="currentTab != -1">
                <app-timeline [steps]="tabs" [currentStep]="currentTab"></app-timeline>
            </div>

            <div class="col-12" *ngIf="currentTab != -1">
                <mat-card>
                    <mat-card-content>
                        <app-device-view [device]="device" [msspItem]="msspItem" [singleDevice]="true">
                        </app-device-view>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-12 my-2">
                <mat-stepper class="stepperHideSteps" linear #stepper>
                    <mat-step>
                        <mat-card class="serviceCard p-0">
                            <mat-card-content>
                                <app-start></app-start>
                            </mat-card-content>
                        </mat-card>
                        <div class="d-none d-sm-none d-md-flex justify-content-end my-5">
                            <button class="w-25 p-1 p-1" type="button" mat-raised-button color="accent"
                                (click)="stepBack(currentTab)" matStepperPrevious> {{ 'SERVICE_PAGE.LABEL3' | translate }} </button>
                            <button class="w-25 p-1 mx-2" type="button" (click)="currentTab = currentTab+1"
                                mat-raised-button matStepperNext color="primary"> {{ 'SERVICE_PAGE.LABEL4' | translate }} </button>
                        </div>
                        <div class="d-block d-sm-block d-md-none w-100">
                            <mat-card class="serviceCard my-3">
                                <mat-card-content>
                                    <button class="w-100 p-1 mx-2" type="button" (click)="currentTab = currentTab+1"
                                        mat-raised-button matStepperNext color="primary"> {{ 'SERVICE_PAGE.LABEL5' | translate }} </button>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </mat-step>
                    <mat-step>
                        <app-personal (personalForm)="stepOn($event)" (personalStepBack)="stepBack($event)"
                            (questionSetItem)="getItem($event)">
                        </app-personal>
                    </mat-step>
                    <mat-step>
                        <app-address (addressForm)="stepOn($event)" (addressStepBack)="stepBack($event)">
                        </app-address>
                    </mat-step>
                    <mat-step>
                        <app-service-data (serviceDataForm)="stepOn($event)" (serviceDataStepBack)="stepBack($event)"
                            (formServiceData)="getServiceDataForm($event)"></app-service-data>
                    </mat-step>
                    <mat-step>
                        <app-service-validation [questionSetItem]="questionItem" [serviceDataForm]="serviceDataForm"
                            (serviceValidationForm)="stepOn($event)" (serviceValidationStepBack)="stepBack($event)">
                        </app-service-validation>
                    </mat-step>
                </mat-stepper>

            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>